module.exports = __webpack_public_path__ + "img/header.62cc36a9.png";